module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    },
    style: ('width:' + _vm.width + 'px')
  }, [(_vm.label) ? _c('label', {
    staticClass: "text-info",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.mask != '') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mask),
      expression: "mask"
    }],
    staticClass: "form-control",
    class: _vm.classes,
    style: ('width:' + _vm.width + 'px'),
    attrs: {
      "type": "text",
      "name": _vm.name,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }) : _c('input', {
    staticClass: "form-control",
    class: _vm.classes,
    style: ('width:' + _vm.width + 'px'),
    attrs: {
      "type": "text",
      "name": _vm.name,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04e63c38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputText.vue
// module id = 948
// module chunks = 34